module.exports = __webpack_public_path__ + "img/34.b4c0eba4.gif";